import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, usePagination, ButtonModifier } from "../../../components";
import { formatDate, formatTime } from "../../../constants/helper";
import { ShowTablePenjualanChild } from "../../../components/ShowTable";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import jsPDF from "jspdf";
import { NumericFormat } from "react-number-format";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilPenjualan = () => {
  const screenSize = useScreenWidth();
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakStruk, setIsCetakStruk] = useState(true);
  const [isPost, setIsPost] = useState("");
  const [createdAtHour, setCreatedAtHour] = useState("");

  // Data Penjualan
  const [noNotaPenjualan, setNoNotaPenjualan] = useState("");
  const [tglPenjualan, setTglPenjualan] = useState("");
  const [userIdKasir, setUserIdKasir] = useState("");
  const [usernameKasir, setUsernameKasir] = useState("");
  const [shiftPenjualan, setShiftPenjualan] = useState("");
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Customer
  const [nopolCustomer, setNopolCustomer] = useState("");
  const [sumberCustomer, setSumberCustomer] = useState("INTERNAL");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [kodeMekanik, setKodeMekanik] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [kodeJenisPembayaran, setKodeJenisPembayaran] = useState("");
  const [potongan, setPotongan] = useState("0");
  const [biayaJenisPembayaran, setBiayaJenisPembayaran] = useState("0");
  const [totalBiaya, setTotalBiaya] = useState("0");
  const [total, setTotal] = useState("0");
  const [bayar, setBayar] = useState("0");
  const [kembali, setKembali] = useState("0");

  // Data Penjualan Kredit
  const [tipePenjualan, setTipePenjualan] = useState("TUNAI");
  const [lamaKredit, setLamaKredit] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState(null);

  const [penjualansChildData, setPenjualansChildData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  let today = new Date();
  let isEditableManager =
    user.tipeUser !== "ADMIN" &&
    user.tipeUser !== "OWNER/DIREKSI" &&
    isPost === false;
  let isEditableAdmin = user.tipeUser !== "OWNER/DIREKSI";
  // let isEditableAdmin =
  //   user.tipeUser === "ADMIN" &&
  //   tglPenjualanDate?.getFullYear() === today.getFullYear() &&
  //   tglPenjualanDate?.getMonth() === today.getMonth() &&
  //   tglPenjualanDate?.getDate() === today.getDate() &&
  //   isPost === false;
  let isEditable = isEditableManager || isEditableAdmin;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(1);
  const PER_PAGE = 20;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Get current posts
  const indexOfLastPost = page * PER_PAGE;
  const indexOfFirstPost = indexOfLastPost - PER_PAGE;
  const currentPosts = penjualansChildData.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const count = Math.ceil(penjualansChildData.length / PER_PAGE);
  const _DATA = usePagination(penjualansChildData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  useEffect(() => {
    getPenjualanById();
  }, []);

  const getPenjualanById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/penjualans/${id}`, {
      _id: user.id,
      token: user.token,
    });
    setIsCetakStruk(response.data.isCetakStruk);
    setIsPost(response.data.isPost);
    let tempCreatedAt = new Date(response.data.createdAt);
    setCreatedAtHour(formatTime(tempCreatedAt));

    // Data Penjualan
    setNoNotaPenjualan(response.data.noNotaPenjualan);
    setTglPenjualan(formatDate(response.data.tglPenjualan));
    setUserIdKasir(response.data.user.id);
    setUsernameKasir(response.data.user.username);
    setShiftPenjualan(response.data.shiftPenjualan);

    // Data Customer
    setNopolCustomer(response.data.nopolCustomer);
    setSumberCustomer(response.data.sumberCustomer);
    setNamaCustomer(response.data.namaCustomer);
    setNoTeleponCustomer(response.data.noTeleponCustomer);
    setKodeMekanik(response.data.mekanik && response.data.mekanik.namaMekanik);

    // Data Total
    setSubtotal(response.data.subtotal);
    setKodeJenisPembayaran(
      response.data.jenispembayaran &&
        response.data.jenispembayaran.namaJenisPembayaran
    );
    setPotongan(response.data.potongan);
    setBiayaJenisPembayaran(response.data.biayaJenisPembayaran);
    setTotalBiaya(response.data.totalBiaya);
    setTotal(response.data.total);
    setBayar(response.data.bayar);
    setKembali(response.data.kembali);

    // Data Penjualan Kredit
    setTipePenjualan(response.data.tipePenjualan);
    setLamaKredit(response.data.lamaKredit);
    setTglJatuhTempo(
      response.data.tglJatuhTempo && formatDate(response.data.tglJatuhTempo)
    );

    const response2 = await axios.post(
      `${tempUrl}/penjualanChildsByPenjualan`,
      {
        penjualanId: response.data.id,
        kodeCabang: response.data.cabangId,
        _id: user.id,
        token: user.token,
      }
    );
    setPenjualansChildData(response2.data);
    setJumlahItem(response2.data.length);
    setLoading(false);
  };

  const updatePenjualanIsCetakStruk = async () => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/updatePenjualanIsCetakStruk/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setIsCetakStruk(true);
      setPreviewPdf(false);
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  const deletePenjualan = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deletePenjualan/${id}`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      navigate("/daftarPenjualan");
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });

    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Penjualan / Servis</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarPenjualan")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewPdf(!previewPdf);
              setIsCetakStruk(false);
            }}
          >
            CETAK
          </Button>
        </ButtonGroup>
      </Box>

      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarPenjualan/penjualan/${id}/edit`}
              deleteUser={deletePenjualan}
              nameUser={noNotaPenjualan}
            />
          </>
        )}
      </Box>

      {previewPdf ||
        (isCetakStruk === false && (
          <div>
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={() => {
                handleGeneratePdf();
                updatePenjualanIsCetakStruk();
              }}
            >
              CETAK
            </Button>
            <div ref={reportTemplateRef} style={cetakContainerKwitansi}>
              <p style={cetakCenter}>{setting.namaPerusahaan}</p>
              <p style={cetakCenter}>
                {setting.alamatPerusahaan} ({setting.kabupatenPerusahaan}){" "}
                {setting.kotaPerusahaan}
              </p>
              <p style={cetakCenter}>TELP. {setting.teleponPerusahaan}</p>
              <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>
                    {tglPenjualan} {createdAtHour} {usernameKasir}
                  </p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>
                    {noNotaPenjualan} / Shift : {shiftPenjualan}
                  </p>
                </div>
              </div>
              {nopolCustomer !== "TUNAI" && (
                <div>
                  <div>
                    <p style={cetakText}>Nopol: {nopolCustomer}</p>
                  </div>
                  <div>
                    <p style={cetakText}>Mekanik: {kodeMekanik}</p>
                  </div>
                </div>
              )}
              <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
              {penjualansChildData.map((penjualansChild, index) => (
                <div>
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: 2 }}>
                      {penjualansChild.stok.namaStok}
                    </div>
                    <div style={{ flex: 1 }}></div>
                    <div style={{ flex: 1, textAlign: "right" }}>
                      / {penjualansChild.stok.satuanKecilStok}
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: 2, textAlign: "center" }}>
                      {penjualansChild.quantity.toLocaleString("de-DE")} x
                    </div>
                    <div style={{ flex: 1, textAlign: "right" }}>
                      {penjualansChild.totalPenjualanChild.toLocaleString(
                        "de-DE"
                      )}
                    </div>
                    <div style={{ flex: 1, textAlign: "right" }}>
                      {penjualansChild.hargaNetto.toLocaleString("de-DE")}
                    </div>
                  </div>
                </div>
              ))}
              <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingLeft: "30px" }}>SubTotal</div>
                <div style={{ flex: 1, textAlign: "center" }}>Rp.</div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  {subtotal.toLocaleString("de-DE")}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingLeft: "30px" }}>Potongan</div>
                <div style={{ flex: 1, textAlign: "center" }}>Rp.</div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  {potongan.toLocaleString("de-DE")}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingLeft: "30px" }}>Biaya</div>
                <div style={{ flex: 1, textAlign: "center" }}>Rp.</div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  {totalBiaya.toLocaleString("de-DE")}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingLeft: "30px" }}>Total</div>
                <div style={{ flex: 1, textAlign: "center" }}>Rp.</div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  {total.toLocaleString("de-DE")}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingLeft: "30px" }}>Bayar</div>
                <div style={{ flex: 1, textAlign: "center" }}>Rp.</div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  {bayar.toLocaleString("de-DE")}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingLeft: "30px" }}>Kembali</div>
                <div style={{ flex: 1, textAlign: "center" }}>Rp.</div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  {kembali.toLocaleString("de-DE")}
                </div>
              </div>

              <div style={{ display: "flex", marginTop: "10px" }}>
                <div style={{ flex: 1 }}>
                  <b>{jumlahItem} ITEM</b>
                </div>
                <div style={{ flex: 1 }}>* {kodeJenisPembayaran} *</div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <p style={cetakCenter}>BARANG YANG SUDAH DIBELI</p>
                <p style={cetakCenter}>TIDAK BISA DIKEMBALIKAN</p>
                <p style={cetakCenter}>TERIMA KASIH</p>
              </div>
            </div>
          </div>
        ))}

      <Form>
        <Card>
          <Card.Header>Data Penjualan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noNotaPenjualan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={tglPenjualan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kasir :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={usernameKasir} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Shift :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={shiftPenjualan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={jumlahItem} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Customer</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={nopolCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Sumber :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={sumberCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={namaCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. HP :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noTeleponCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Mekanik :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeMekanik} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <ShowTablePenjualanChild id={id} currentPosts={currentPosts} />
      </Box>

      <Card style={{ marginTop: 10 }}>
        <Card.Header>Data Total</Card.Header>
        <Card.Body>
          <Box sx={textFieldContainer}>
            <Box sx={textFieldWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Subtotal :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={subtotal}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Potongan :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={potongan}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Jenis Pembayaran :
                    </Form.Label>
                    <Col sm="7">
                      <Form.Control value={kodeJenisPembayaran} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Biaya :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={totalBiaya}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Total :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={total}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Bayar :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={bayar}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Kembali :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={kembali}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[textFieldWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Tipe Penjualan :
                    </Form.Label>
                    <Col sm="7">
                      <Form.Control value={tipePenjualan} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Lama Kredit :
                    </Form.Label>
                    <Col sm="7">
                      <Form.Control value={lamaKredit} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Tgl. Jatuh Tempo :
                    </Form.Label>
                    <Col sm="7">
                      <Form.Control value={tglJatuhTempo} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilPenjualan;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};

const downloadButtons = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const cetakContainerKwitansi = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  width: "330px",
  padding: "20px",
  paddingTop: "0px",
  // marginLeft: "35px",
  marginLeft: "15px",
};

const cetakCenter = {
  // fontSize: "12px",
  fontSize: "14px",
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakText = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
};
